export const legacyToolbarColors = {
  textColor: '#f2f2f2',
  undo: '#09509d',
  clear: '#9c276d',
  double: '#fd9e47',
  rebet: '#046e74',
  fold: '#9c276d',
} as const;
